/**
 * What a reviewer sees of a notice, per portal (05-10-2026).
 *
 * The request page and the full notice page both name the same fields and
 * both reach the same reviewer-authorised detail endpoints, so the two live
 * here instead of being copied into each page.
 */
import { NOTICES } from "../../api/endpointMap";

export const NOTICE_FIELD_LABELS = {
  "E Proceeding": [
    ["client_name", "Client"],
    ["proceeding_name", "Proceeding Name"],
    ["notice_section", "Section"],
    ["assessment_year", "Assessment Year"],
    ["financial_year", "Financial Year"],
    ["response_status", "Response Status"],
  ],
  "Response to Outstanding Demand": [
    ["client_name", "Client"],
    ["demand_reference_no", "Demand Reference No."],
    ["section_code", "Section Code"],
    ["assessment_year", "Assessment Year"],
    ["date_of_demand_raised", "Demand Raised"],
    ["response_status", "Response Status"],
  ],
  "GST Notice And Order": [
    ["client_name", "Client"],
    ["notice_id", "Notice ID"],
    ["issued_by", "Issued By"],
    ["type", "Type"],
    ["description", "Description"],
    ["amount", "Amount"],
    ["issue_date", "Issue Date"],
    ["due_date", "Due Date"],
    ["response_status", "Response Status"],
  ],
  "GST Additional Notice And Order": [
    ["client_name", "Client"],
    ["ref_id", "Ref ID"],
    ["arn", "ARN"],
    ["type", "Type"],
    ["description", "Description"],
    ["notice_status", "Notice Status"],
    ["issue_date", "Issue Date"],
    ["due_date", "Due Date"],
    ["response_status", "Response Status"],
  ],
  Quarter: [
    ["client_name", "Client"],
    ["quarter_name", "Quarter"],
    ["financial_year", "Financial Year"],
    ["form_type", "Form Type"],
    ["request_number", "Request Number"],
    ["status", "Status"],
  ],
};

// Reviewer-authorised BE detail endpoint per notice type (data only,
// no tenant frontend involved). Used by the Open Notice drawer.
export const noticeDetailUrl = (noticeType, noticeId) => {
  const id = encodeURIComponent(noticeId);
  switch (noticeType) {
    case "E Proceeding":
      return `/api/v1/income-tax/e-proceedings/${id}`;
    case "Response to Outstanding Demand":
      return `/api/v1/income-tax/response-outstandings/${id}`;
    case "GST Notice And Order":
      return `${NOTICES.GST_LIST}/${id}`;
    case "GST Additional Notice And Order":
      return `${NOTICES.GST_ADDITIONAL_LIST}/${id}`;
    case "Quarter":
      return `/api/v1/tds/quarters/${id}`;
    default:
      return null;
  }
};
